<template>
  <div
    class="select-none transform transition-all duration-600 h-10 bg-secondary-800 text-white rounded-md flex items-center text-sm">
      <slot name="commons" />
      <div class="hidden md:block">
        <slot name="desktop" />
      </div>
      <div
        ref="moreSection"
        v-outside:click="{ exclude: ['moreSection'], handler: closeMore }"
        class="relative">
        <span class="flex group" :class="{ disabled: disabled }">
          <base-button class="!rounded-r-none md:pl-6 md:pr-2 pl-4 pr-1"
            :mode="mode" :loading="loading" :disabled="disabled" @click="mainClick">
            <span class="count font-bold whitespace-nowrap w-18 text-center"> {{ name }}</span>
          </base-button>
          <base-button class="!rounded-l-none md:px-2.5 px-2 group-hover:cbutton--primary"
            :mode="mode" group @click="toggleMore">
            <base-icon v-if="baseDropDownVisible" 
              :class="{ 'transform rotate-180': more }"
              class="transition-transform duration-300"
              name="chevronup"/>
          </base-button>
        </span>
        <base-drop-down v-if="baseDropDownVisible" 
          autoClose=true 
          :isOpen="more" 
          position="bottom-right" 
          customClass="w-72 p-1 bg-secondary-800 bottom-10" 
          @toggle="closeMore" >
          <slot name="more" />
        </base-drop-down>
      </div>
    </div>
</template>

<script>
export default {
  name: 'base-table-select-more-actions-form',
  props: {
    name: {
      type: [String],
      default: 'Acciones'
    },
    baseDropDownVisible: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'primary',
      validator: function (value) {
        return ['primary', 'staticprimary', 'secondary', 'primary-phantom', 'staticprimary-phantom', 'secondary-phantom', 'secondary-phantom-blue', 'primary-line', 'tools', 'core'].indexOf(value) !== -1
      }
    },
  },
  data: function () {
    return {
      more: false
    }
  },
  computed: {
  },
  methods: {
    mainClick: function () {
      this.$emit('mainclick')
    },
    toggleMore: function () {
      this.more = !this.more
    },
    closeMore: function () {
      this.more = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
